// src/data/serumsImg/greenSetImages.js

export const greenSetImages = {
  imgBanner: require("../../img/jetCare-serums/green-cover.png"),
  imgModal: require("../../img/jetCare-serums/JetCare Green_Set.png"),
  productsImages: {
    "jetCare-green-hydro": {
      image: require("../../img/jetCare-serums/JetCare Green Hydro.png"),
      imageBig: require("../../img/jetCare-serums/green_hydro.png"),
    },
    "jetCare-green-exfoliation": {
      image: require("../../img/jetCare-serums/JetCare Green Exfoliation.png"),
      imageBig: require("../../img/jetCare-serums/Green Exfoliation.png"),
    },
    "jetCare-green-glow": {
      image: require("../../img/jetCare-serums/JetCare Green Glow.png"),
      imageBig: require("../../img/jetCare-serums/Green Glow.png"),
    },
    "jetCare-green-peptide-complex": {
      image: require("../../img/jetCare-serums/JetCare Green Peptide Complex.png"),
      imageBig: require("../../img/jetCare-serums/green_Peptide_complex.png"),
    }
  }
};
